import { historyGetIsChangedStyle } from '@utils/historyGetIsChangedStyle';
import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';
import type { CatalogUerBaseCostWorkScopeItems } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';

interface IUsePriceHistoryColumnsProps {
    nameFilterData: { name: string }[] | undefined;
    handleFilterChange: ({ filterType, value }: { filterType: 'nameFilter'; value: string[] | null }) => void;
}

export const usePriceHistoryColumns = ({ nameFilterData, handleFilterChange }: IUsePriceHistoryColumnsProps) => {
    const onFilterChange = useCallback(
        ({ fullDataSet }: { fullDataSet: { data: { name: string } }[] }) => {
            handleFilterChange({
                filterType: 'nameFilter',
                value: fullDataSet?.map((item: { data: { name: string } }) => item?.data?.name),
            });
        },
        [handleFilterChange],
    );

    return useMemo<ColDef<CatalogUerBaseCostWorkScopeItems>[]>(
        () => [
            {
                field: 'number',
                headerName: '№ пп',
                cellClass: historyGetIsChangedStyle({
                    customKey: 'workScopeNumberCng',
                }),
            },
            {
                field: 'name',
                headerName: 'Наименование',
                flex: 1,
                cellClass: historyGetIsChangedStyle({
                    customKey: 'workScopeNameCng',
                }),
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    filterItems: nameFilterData,
                    isClientSideSearch: true,
                    hideTableHeader: true,
                    changeFilterHandler: onFilterChange,
                    columns: [
                        {
                            headerName: 'Наименование',
                            field: 'name',
                            checkboxSelection: true,
                        },
                    ],
                },
            },
        ],
        [nameFilterData, onFilterChange],
    );
};
